import BlockRenderer from "./BlockRenderer"
import CustomHelperText from "./CustomHelperText"
import { TransitionRight } from "./transitions/TransitionRight"
import { TransitionUp, TransitionUpComponent } from "./transitions/TransitionUp"
import { useTransitionUpStyles } from "./transitions/useTransitionUpStyles"
import {
  styleObjectToCss,
  delayTime as transitionDelayTime,
  transitionTime,
  useInViewConfig,
} from "./transitions/utils"
export {
  BlockRenderer,
  CustomHelperText,
  styleObjectToCss,
  transitionDelayTime,
  TransitionRight,
  transitionTime,
  TransitionUp,
  TransitionUpComponent,
  useInViewConfig,
  useTransitionUpStyles,
}

export {
  CustomCheckbox,
  CustomSelect,
  CustomTextField,
  MultilineCustomTextField,
} from "./form"

export { commonSchema } from "./FormSchema"

export { CustomBreadcrumbs } from "./CustomBreadcrumbs"

import Articles from "./Articles"
import Banner from "./Banner"
import BranchCard from "./BranchCard"
import CalculatorContent from "./CalculatorContent"
import CarImagePlaceholder from "./CarImagePlaceholder"
import CarsSwiper from "./CarsSwiper"
import ComparisonBox from "./ComparisonBox"
import FormBlock from "./FormBlock"
import Layout from "./layout/Layout"
import Marketing from "./Marketing"
import PreviouslyViewed from "./PreviouslyViewed"
import ReasonsWhy from "./ReasonsWhy"
import ReCaptchaDisclaimer from "./ReCaptchaDisclaimer"
import Result from "./Result"
import TextImageBlock from "./TextImageBlock"
export {
  Articles,
  Banner,
  BranchCard,
  CalculatorContent,
  CarImagePlaceholder,
  CarsSwiper,
  ComparisonBox,
  FormBlock,
  Layout,
  Marketing,
  PreviouslyViewed,
  ReasonsWhy,
  ReCaptchaDisclaimer,
  Result,
  TextImageBlock,
}

export { ComparisonProvider, useComparison } from "./contexts/ComparisonContext"
export type { CarType } from "./contexts/ComparisonContext"

export * from "./MediaQueries"
export { sharedColors } from "./theme/colors"
export { mediaQueries } from "./theme/mediaQueries"
export * from "./theme/theme"
